<template>
  <v-layout wrap>
    <v-expansion-panel>
      <v-toolbar
        class="toolbar"
        flat
        dark
      >
        <v-toolbar-title>
          Order:
          <b>{{ order.id }} / {{ order.orderRef }}</b>
        </v-toolbar-title>

        <v-spacer />
        <v-toolbar-side-icon />
      </v-toolbar>
      <v-expansion-panel-content :value="detailsOpen">
        <div slot="header">
          <v-layout class="orderDetails">
            <v-flex
              xs12
              class="orderField text-xs-center"
            >
              <v-chip
                label
                color="#1A4C7D"
                text-color="white"
              >
                <v-icon left>
                  attach_money
                </v-icon>Amount:
                <span>
                  <b>{{ order.amount | currency('€') }}</b>
                </span>
              </v-chip>
            </v-flex>
            <v-flex
              xs12
              class="orderField text-xs-center"
            >
              <v-chip
                label
                color="grey darken-2"
                text-color="white"
              >
                <v-icon left>
                  info
                </v-icon>Status:
                <span>
                  <b>{{ order.status }}</b>
                </span>
              </v-chip>
            </v-flex>
            <v-flex
              xs12
              class="orderField text-xs-center"
            >
              <v-chip
                label
                color="grey darken-3"
                text-color="white"
              >
                <v-icon left>
                  payment
                </v-icon>Type:
                <span>
                  <b>{{ order.type }}</b>
                </span>
              </v-chip>
            </v-flex>
          </v-layout>
        </div>
        <v-card>
          <v-layout row>
            <v-flex xs12>
              <v-card class="container">
                <v-list two-line>
                  <br>
                  <h3>Account</h3>
                  <br>
                  <v-layout class="orderDetails">
                    <v-flex class="text-xs-center">
                      <v-text-field
                        :editable="false"
                        readonly
                        label="Account name"
                        :value="order.accountName"
                      />
                    </v-flex>
                    <v-flex class="text-xs-center">
                      <v-text-field
                        :editable="false"
                        readonly
                        label="Created at"
                        :value="formatDate(order.createdAt)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout class="orderDetails">
                    <v-flex xs12>
                      <v-text-field
                        readonly
                        label="Account BIC"
                        :value="order.accountBIC"
                      />
                      <v-text-field
                        readonly
                        label="Account BAN"
                        :value="order.accountIBAN"
                      />
                    </v-flex>
                  </v-layout>
                  <div v-if="order.debitMsgDetails">
                    <br>
                    <h3>Debit</h3>
                    <br>
                    <v-layout class="orderDetails">
                      <v-flex class="text-xs-center pr-1">
                        <v-text-field
                          :editable="false"
                          readonly
                          label="Debit message ID"
                          :value="order.debitMsgId ? order.debitMsgId : ''"
                          append-icon="link"
                          @click:append="goToDebitMsgDetails(order.debitMsgId)"
                        />
                        <v-text-field
                          :editable="false"
                          readonly
                          label="Status"
                          :value="order.debitMsgDetails.status.value ?
                            order.debitMsgDetails.status.value : ''"
                        />
                      </v-flex>
                      <v-flex class="text-xs-center pl-1">
                        <v-text-field
                          :editable="false"
                          readonly
                          label="Execution date"
                          :value="order.debitMsgDetails.createdAt ?
                            formatDate(order.debitMsgDetails.createdAt) : ''"
                        />
                        <v-text-field
                          :editable="false"
                          readonly
                          label="Status changed"
                          :value="order.debitMsgDetails.status.changedAt ?
                            formatDate(order.debitMsgDetails.status.changedAt ) : ''"
                        />
                      </v-flex>
                    </v-layout>
                  </div>
                  <v-divider />
                  <br>
                  <h3>Order</h3>
                  <br>
                  <template>
                    <v-layout row>
                      <v-flex
                        xs12
                        class="orderField text-xs-center"
                      >
                        <v-text-field
                          readonly
                          label="Name"
                          :value="order.name"
                          append-icon="link"
                          @click:append="goToUserDetails(order.extUserId)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        class="orderField text-xs-center"
                      >
                        <v-text-field
                          readonly
                          label="External order ID"
                          :value="order.extOrderId"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        class="orderField text-xs-center"
                      >
                        <v-text-field
                          readonly
                          label="External user ID"
                          :value="order.extUserId"
                        />
                      </v-flex>
                    </v-layout>
                  </template>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-content>
        <div slot="header">
          <h3>
            Transactions
            <b>({{ order.transactions ? order.transactions.data.length || 0 : 0 }})</b>
          </h3>
        </div>
        <v-card class="container transactions">
          <v-container
            v-for="(item, transactionIndex) in order.transactions.data"
            :key="item.id"
            grid-list-md
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs8
                text-xs-left
              >
                <p class="ma-1">
                  Name:
                  <span v-if="item.name">
                    <span
                      v-for="(name, nameIndex) in Array.from(item.name)"
                      :key="nameIndex"
                    >
                      <b>{{ name }}</b>
                      <span v-if="nameIndex < item.name.length - 1">/</span>
                    </span>
                  </span>
                </p>
                <p class="ma-1">
                  <span class="longTitle">
                    Subject:
                    <b>{{ item.subject }}</b>
                  </span>
                </p>
                <p class="ma-1">
                  <span>
                    Account IBAN:
                    <b>{{ item.accountNumber }}</b>
                  </span>
                </p>
                <p class="ma-1">
                  <span>
                    Account BIC:
                    <b>{{ item.accountBankCode }}</b>
                  </span>
                </p>
                <p class="ma-1">
                  <span>
                    Created at:
                    <b>{{ formatDate(item.date) }}</b>
                  </span>
                </p>
              </v-flex>
              <v-flex
                xs4
                text-xs-center
              >
                <v-chip
                  label
                  color="blue darken-3"
                  text-color="white"
                >
                  <v-icon left>
                    monetization_on
                  </v-icon>Amount:
                  <span>
                    <b>{{ item.amount | currency('€') }}</b>
                  </span>
                </v-chip>
                <div
                  v-if="item.matchingsAmount && item.matchingsAmount.length"
                  class="text-xs-center"
                >
                  <span
                    slot="badge"
                    dark
                    small
                  />

                  <b>Matched ({{ item.matchingsAmount.length }})</b>

                  <p
                    v-for="(value, amountIndex) in item.matchingsAmount"
                    :key="amountIndex"
                    class="ma-0"
                  >
                    <span>{{ value.toFixed(2) | currency('€') }}</span>
                  </p>
                </div>
                <div class="grey--text text--lighten">
                  <span>
                    Status:
                    <b>{{ item.status }}</b>
                  </span>
                </div>
                <div class="grey--text text--lighten">
                  <span>
                    Updated at:
                    <b>{{ formatDate(item.updatedAt.date) }}</b>
                  </span>
                </div>
              </v-flex>
            </v-layout>
            <v-divider :key="transactionIndex" />
          </v-container>
          <div
            v-if="!order.transactions || order.transactions.data.length == 0"
          >
            No transaction data.
          </div>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OrdersDetails',
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      detailsOpen: false,
    };
  },
  async mounted() {
    if (this.order.debitMsgId) {
      this.order.debitMsgDetails = await this.getDebitMessage(
        this.order.debitMsgId,
      ).then(data => data);
    }

    this.detailsOpen = true;
  },
  methods: {
    ...mapActions(['getDebitMessage']),
    goToDebitMsgDetails(id) {
      this.$router.push({ name: 'debit_message_detail', params: { id } });
    },
    formatDate(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    goToUserDetails(id) {
      this.$router.push({ name: 'user_detail', params: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.orderDetails {
  padding-left: 16px;
  padding-right: 16px;
}
.orderField {
  padding: 8px;
}
.transactions {
  min-height: 200px;
  overflow-y: auto;
}
.transactionField {
  padding-top: 8px;
}
.toolbar {
  background-color: #1a4c7d;
}
.v-list__tile__sub-title,
.v-list__tile__title {
  white-space: unset;
  overflow: unset;
  text-overflow: unset;
}

.v-list__tile__action--stack {
  justify-content: flex-start;
  align-items: center;
}
.v-list__tile__content {
  justify-content: flex-start !important;
}
</style>



// WEBPACK FOOTER //
// src/components/orders/OrderDetails.vue